var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandIconTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8873 12.4825L23.2651 4.08429H21.5174L15.1086 11.3749L9.99366 4.08429H4.09277L11.8292 15.11L4.09277 23.9157H5.84045L12.604 16.215L18.0068 23.9157H23.9077M6.47123 5.3749H9.15615L21.5161 22.6885H18.8305",
    fill: "#F7F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandIconTwitter);
export default __webpack_public_path__ + "static/media/brand-icon_twitter.3e3a5773a7262fa48b8d1ec7746eeef4.svg";
export { ForwardRef as ReactComponent };